import { BaseNav, useAuth, useNavItemStore } from '@cksoftware/react-base';
import { HStack, Icon, IconButton, Image, Text, VStack } from '@chakra-ui/react';
import logo from '../../../assets/logo.png';
import { DlmsUser, getCurrentProfile } from '../../../globalModels/user/dlmsUser.ts';
import { useProfileItems } from '../../layout/useProfileItems.ts';
import { Link } from 'react-router-dom';
import { ConductionAuctionButton } from '../../../features/header/components/conductionAuctionButton.tsx';
import { LuMenu } from 'react-icons/lu';
import { faChevronDown, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  onMenuClick: () => void;
  showMenuButton: boolean;
  hideNav: boolean;
}

export const ClientHeader = (props: Props) => {
  const routeNav = useNavItemStore((state) => {
    return { items: state.getDefault(), get: state.get };
  });

  const auth = useAuth<DlmsUser>();
  const profileItems = useProfileItems();
  const currentProfile = getCurrentProfile(auth.user);

  const customProfileTrigger = currentProfile ? (
    <HStack cursor='pointer' px={3} py={2} borderRadius='md' gap={2}>
      <VStack align='start' gap={0}>
        <Text>Welcome back,</Text>
        <Text>
          {currentProfile.FirstName} {currentProfile.LastName}
        </Text>
      </VStack>
      <Icon w={'15px'} h={'100%'}>
        <FontAwesomeIcon icon={faChevronDown} />
      </Icon>
      <Icon w={'30px'} h={'30px'}>
        <FontAwesomeIcon icon={faUser} />
      </Icon>
    </HStack>
  ) : null;

  return (
    <BaseNav.Header
      navItems={!props.hideNav ? routeNav.items : []}
      profileItems={profileItems}
      avatarName={`${currentProfile?.FirstName} ${currentProfile?.LastName}`}
      profileTrigger={customProfileTrigger}
      logo={
        <HStack>
          {!props.showMenuButton && (
            <IconButton hideFrom={'lg'} aria-label='Open Menu' onClick={props.onMenuClick}>
              <LuMenu />
            </IconButton>
          )}
          <Link to={'/'}>
            <Image height={['65px']} src={logo} alt='logo' />
          </Link>
        </HStack>
      }>
      {!props.hideNav && <ConductionAuctionButton />}
    </BaseNav.Header>
  );
};
